import React, { createContext, useState } from "react";

type PrimaryMenuType = "HOME" | "BUILD" | "ANALYZE" | null;

type SideBarContextType = {
    selectedPrimaryMenu: PrimaryMenuType;
    setSelectedPrimaryMenu: Function;
    showPrimaryMenu: boolean;
    setShowPrimaryMenu: Function;
};

const SideBarContext = createContext<SideBarContextType>({
    selectedPrimaryMenu: null,
    setSelectedPrimaryMenu: function (menu: string) {},
    showPrimaryMenu: false,
    setShowPrimaryMenu: function (status: boolean) {}
});

export const SideBarContextProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
    const [selectedPrimaryMenu, setSelectedPrimaryMenu] = useState(null);
    const [showPrimaryMenu, setShowPrimaryMenu] = useState(false);

    const context = {
        selectedPrimaryMenu,
        setSelectedPrimaryMenu,
        showPrimaryMenu,
        setShowPrimaryMenu
    };

    return <SideBarContext.Provider value={context}>{children}</SideBarContext.Provider>;
};

export default SideBarContext;
